<div class="flex justify-center w-full md:mt-11 pb-8">
    <img src="assets/icons/Icons/other-payment-options/payment-ozow_eft.png" alt="ozow logo">
</div>
<div class="w-full">
    <p class="my-6">Pay securely via direct EFT using Ozow&#33; </p>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 1:</b>
        <p class="col-span-3 md:col-span-5">Select your bank. We have all 9 of South Africa&#39;s major banks available to choose from</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 2:</b>
        <p class="col-span-3 md:col-span-5">Log in and select the account you want to pay from </p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 3:</b>
        <p class="col-span-3 md:col-span-5">Accept the two-factor authentication request from your bank, and that&#39;s it&#33;</p>
    </div>
</div>